// extracted by mini-css-extract-plugin
export default {"timer":"VerificationModal_timer__jjA8f","timer_active":"VerificationModal_timer_active__vy9ji","verification":"VerificationModal_verification__I07y8"};